import { render } from "./remove-host-btn.vue?vue&type=template&id=1098e770"
import script from "./remove-host-btn.vue?vue&type=script&lang=js"
export * from "./remove-host-btn.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_ed238492/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__